import { i18n } from '@lingui/core';
import { Alert } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons';

const QuestionnaireAlert = () => (
  <Alert
    mb="sm"
    icon={<IconInfoCircle />}
    title="Sind im PDF große Bereiche weiß? Dieser Tipp hilft Dir!"
    sx={(theme) => ({ backgroundColor: theme.colors.lightBlue[0] })}
  >
    {i18n._('questionnaire.tip.helper')}
  </Alert>
);

export default QuestionnaireAlert;
